import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trading volume 197",
  "use": "icon-trading volume 197-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-trading volume 197\"><path d=\"M245.333333 245.333333V768H810.666667v64H277.333333a96 96 0 0 1-96-96v-490.666667h64z m581.141334-42.666666V426.666667h-64v-111.082667l-194.688 199.701333-61.653334-63.872-141.781333 146.816-46.037333-44.458666 187.797333-194.517334 61.909333 64.128 152.746667-156.714666h-102.464v-64h208.170667z\" p-id=\"16079\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol